import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import duplicateEstimate from '../../actions/copyEstimate';
import DuplicateEstimateButton from './DuplicateEstimateButton';
import { create } from '../../helpers/validationFunctionFactory';

const mapStateToProps = ({ estimateBuilder }) => {
  const { estimates } = estimateBuilder.entities;
  const nameList = estimates.allIds.map(givenId => estimates.byId[givenId].name);

  const validateFunction = create(nameList, 50, 'Design name');

  return {
    validate: validateFunction,
    defaultName: `Design ${estimates.allIds.length + 1}`,
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ duplicateEstimate }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateEstimateButton);
